<template>
  <base-button
    :class="$style.container"
    @click="$emit('click')"
  >
    <strong
      v-text="subscriberCount.active"
    ></strong>
    <span
      v-text="$t('common.subscribers')"
    ></span>
  </base-button>
</template>

<script>
import BaseButton from 'atoms/base/BaseButton';

export default {
  name: 'SubscribersCounterText',
  components: {
    BaseButton,
  },
  props: {
    subscriberCount: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="sass" module>
  .container
    max-width: 160px
    height: 60px
    flex: none
    margin: 0 20px 0 auto
    padding-left: 20px
    display: flex
    flex-direction: column
    justify-content: center
    border-left: 1px solid #3D3E50

    span
      font-size: 14px
      font-weight: 500
      line-height: 17px

    strong
      font-weight: bold
      font-size: 18px
      line-height: 22px
</style>
